<template>
  <v-app>
    
    <!-- Top navigation -->
    <!-- <v-navigation-drawer
      v-model="drawer"
      stateless
      fixed
      app
      >
      <v-list dense>
        <v-list-tile @click="">
          <v-list-tile-action>
            <v-icon>home</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Home</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile @click="">
          <v-list-tile-action>
            <v-icon>contact_mail</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Contact</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer> -->
    
    <v-toolbar color="primary lighten-1" :absolute="true" dense dark app v-if="shouldShowHeader()">      
      <v-toolbar-title class="font-weight-light grow"><a href="/" class="white--text nodeco">Turing Form</a></v-toolbar-title>
      <v-spacer></v-spacer>

      <v-avatar v-if="this.avatarUrl" :size="32" color="grey lighten-4">
        <img :src="this.avatarUrl" alt="avatar">
      </v-avatar>
      <v-btn v-if="this.userObj" flat @click="signout()">Logout</v-btn>
    </v-toolbar>

    <v-flex>
      
      <div id="app" class="my-5 pt-3 pb-5">
        <!-- <div id="nav">
          <router-link to="/">Home</router-link> |
          <router-link to="/about">About</router-link>
        </div> -->
        <router-view :key="$route.fullPath"></router-view>
      </div>

      <!-- Footer -->
      <v-footer height="auto" color="primary lighten-1" :absolute="true">
        <v-layout justify-center row wrap>
          <v-btn color="white" flat small round href="/">
            Home
          </v-btn>
          <v-btn color="white" flat small round href="http://turingform.com/termsofservice.md">
            Terms
          </v-btn>
          <v-btn color="white" flat small round href="http://turingform.com/privacypolicy.md">
            Privacy
          </v-btn>

          <router-link to="/view/f_dbc99220662e11e9b038eff39d34340e">
            <v-btn color="white" flat small round>
              Contact Us
            </v-btn>
          </router-link>
          <v-flex primary lighten-2 py-0 text-xs-center white--text xs12>
            <span>&copy;2019 — <strong>Turing Form</strong></span>
          </v-flex>
        </v-layout>
      </v-footer>
    </v-flex>

  </v-app>
</template>

<script>

export default {
  name: 'App',
  components: {
  },
  data: () => ({
    drawer: false,
    userObj: null,
    avatarUrl: null
  }),
  computed: {
    isPremium() {
      return this.$store.state.isPremium;
    },
    isPremiumForm() {
      return this.$store.state.isPremiumForm;
    }
  },
  created() {
    firebase.auth().onAuthStateChanged((user)=> {
      if (user) {
        // User is signed in.
        this.userObj = user;
        this.avatarUrl = user.photoURL;

        this.$store.dispatch('setLogin', { 
          authenticated : true,
          avatarUrl : this.avatarUrl,
          uid : user.uid,
          email : user.email
        });
        // Query user data and store in Vuex
        var db = firebase.firestore();
        db.collection("users").doc(user.uid).get()
        .then((doc)=> {
          if (doc.data()) {
            // user doc exists.
            this.$store.commit('setPremiumState', doc.data().premium);
          } else {
            // No doc
            this.$store.commit('setPremiumState', false);
          }
        })
        .catch((error)=> {
          console.error(error);
        });
      } else {
        this.userObj = null;
        this.$store.commit('logoutUser');
      }
    });
  },
  methods: {
    shouldShowHeader() {
      if (this.$route.name === 'create')  return true;
      if (this.$route.name === 'myforms') return true;
      if (this.$route.name === 'view')    return false;
      if (this.userObj) return true;
      return false;
    },
    showFooter() {
      // Hide footer if premium form
      return !(this.$route.name === 'view' && this.isPremiumForm);
    },
    signout() {
      firebase.auth().signOut();
      this.$store.commit('logoutUser');
      // Go back home to force cache clear
      window.location.href = '/';
    }
  }
}
</script>

<style>
body {
  background-color: white;
}

a {
  text-decoration: inherit;
}

#app {
  background-color: white;
  font-family: Roboto, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.nodeco {
  text-decoration: none;
}

.negativeTopbarMargin {
  margin-top  :-80px; 
  padding-top :-16px;
}


/*#app {
    background: url(https://cdn.vuetifyjs.com/images/parallax/material.jpg);
    background-repeat: no-repeat;
    background-size: auto;
  }*/
</style>
